import { useState } from 'react';

export interface OnRampButtonProps {
  readonly onClick: (amountUsd: number) => Promise<void>;
  readonly disabled?: boolean;
  readonly defaultAmount?: number;
}

export function OnRampButton({ onClick, disabled, defaultAmount = 50 }: OnRampButtonProps) {
  const [amount, setAmount] = useState(defaultAmount);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClick = async (): Promise<void> => {
    setError(null);
    setSubmitting(true);
    try {
      await onClick(amount);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'On-ramp failed to open');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="cp-card" aria-label="onramp-card">
      <label htmlFor="cp-fiat-amount" style={{ fontSize: 13, color: 'var(--muted)' }}>
        Yüklenecek tutar (USD)
      </label>
      <input
        id="cp-fiat-amount"
        className="cp-input"
        type="number"
        min={10}
        max={5000}
        step={10}
        value={amount}
        onChange={(e) => setAmount(Number(e.target.value))}
        style={{ marginTop: 4, marginBottom: 12 }}
        disabled={disabled || submitting}
      />
      <button
        type="button"
        className="cp-button"
        onClick={handleClick}
        disabled={disabled || submitting || amount <= 0}
      >
        {submitting ? 'Açılıyor…' : 'Kart / Havale ile yükle'}
      </button>
      {error ? <div className="cp-error">{error}</div> : null}
    </div>
  );
}
